<template>
  <div
    id="app"
    ref="app"
    :style="{ backgroundColor: mainData.index_bg_color || '#FF7163' }"
  >
    <!-- <TitleBar :title_data="titleData"></TitleBar> -->
    <div
      class="header"
      :style="{ backgroundImage: `url(${mainData.page_top_image})` }"
    ></div>
    <!-- <div class="coin"></div> -->
    <div class="content" :style="{ backgroundColor: mainData.index_bg_color }">
      <div class="guide-desc" v-html="mainData.award_guide_desc"></div>
      <div class="get-reward-content">
        <!-- 支付宝金刚位 -->
        <div
          v-if="isAliPayMainEntry && isInAlipay"
          class="btn-reward"
          :class="{ 'btn-reward-out': true }"
          :style="{ backgroundColor: mainData.award_button_color }"
          v-html="mainData.award_button_text"
          @click="authCodeGetReward"
        ></div>
        <!-- 不支持端外领券 或是领券弹窗 && 不在端内 -->
        <div
          v-if="
            !(isInAlipay && mainData.no_verify) &&
              ((!isOuterActivity && !isInAmap) ||
                (mainData.phone_page_type === 1 && !isInAmap))
          "
          class="btn-reward"
          :class="{ 'btn-reward-out': true }"
          :style="{ backgroundColor: mainData.award_button_color }"
          @click="opentel"
          v-html="mainData.award_button_text"
        ></div>
        <!-- 端外领券 -->
        <div
          class="input_content-wrap"
          v-if="
            (isOuterActivity &&
              mainData.phone_page_type === 2 &&
              !isInAmap &&
              !isInAlipay) ||
              (!isInAmap &&
                isInAlipay &&
                !mainData.no_verify &&
                isOuterActivity &&
                mainData.phone_page_type === 2)
          "
        >
          <div class="line_wrap">
            <input
              v-model="telNum"
              type="tel"
              class="tel input"
              placeholder="请输入手机号"
              :maxlength="11"
              @focus="setViewArea('phone')"
              @blur="temporaryRepair"
            />
          </div>
          <div class="line_wrap vali_wrap">
            <input
              v-model="validNum"
              type="number"
              placeholder="手机验证码"
              class="vali_num input"
              @focus="setViewArea('code')"
              @input="handleInputLength"
              @blur="temporaryRepair"
            />
            <div
              class="vali_btn"
              :class="{ disablevali: !telStatus || !validBtnStatus }"
              @click="getValidNum"
            >
              {{ validBtnText }}
              <span v-if="validBtnText !== '获取验证码'">s</span>
            </div>
          </div>
          <div
            class="btn-reward"
            :class="{ disable: !validStatus || !this.telStatus }"
            :style="{
              backgroundColor:
                !validStatus || !this.telStatus
                  ? '#c9c9c9'
                  : mainData.award_button_color
            }"
            @click="handleGetVoucher"
            v-html="mainData.award_button_text"
          ></div>
        </div>
        <!--支付宝领券，且服务下发为false代表需要验证的，展示手机号+领券按钮 -->
        <div class="input_content-wrap" v-if="isInAlipay && mainData.no_verify">
          <div class="line_wrap">
            <input
              v-model="telNum"
              type="tel"
              class="tel input"
              placeholder="请输入手机号"
              :maxlength="11"
              @focus="setViewArea('phone')"
              @blur="temporaryRepair"
            />
          </div>
          <div
            class="btn-reward"
            :class="{ disable: !this.telStatus }"
            :style="{
              backgroundColor: !this.telStatus
                ? '#c9c9c9'
                : mainData.award_button_color
            }"
            @click="handleGetVoucher"
            v-html="mainData.award_button_text"
          ></div>
        </div>
        <!-- 端内领券 -->
        <div class="input_content-wrap" v-if="isInAmap">
          <div class="line_wrap">
            <input
              v-model="telNum"
              type="tel"
              class="tel input"
              placeholder="请输入手机号"
              :maxlength="11"
              @blur="temporaryRepair"
            />
          </div>
          <div
            class="btn-reward"
            :class="{ disable: !this.telStatus }"
            :style="{
              backgroundColor: !this.telStatus
                ? '#c9c9c9'
                : mainData.award_button_color
            }"
            @click="handleGetVoucher"
            v-html="mainData.award_button_text"
          ></div>
        </div>
      </div>
      <div></div>
      <!-- <div class="error" @click="opentel">获取验证码</div> -->
      <!-- 模拟自动输入 打车比价可能用到 -->
      <!-- <div ref="startPoi">{{startPoiName}}</div> -->
      <div 
        class="clause-body"
        v-if="isAgreeState && !isInAmap && !isInAlipay && (mainData.phone_page_type === 1 || mainData.phone_page_type === 2)"
      >
        <input 
          type="checkbox"
          id="clauseBox"
          class="clause-input" 
          v-model="isAgreeClause"
          @change="selectCheckBox"
        >
        <label for="clauseBox">
          <span>我已阅读并同意</span>
          <a href="http://cache.amap.com/h5/h5/publish/241/index.html">高德地图服务条款</a>
          <span>和</span>
          <a href="http://cache.amap.com/h5/h5/publish/238/index.html">隐私权政策</a>
        </label>
      </div>
      <div class="rule-content">
        <div class="rule-title"></div>
        <div class="rule-desc" v-html="mainData.rule_desc"></div>
      </div>
      <div
        class="logo"
        :style="{
          backgroundImage: `url(${mainData.logo})`,
          backgroundSize: '100% 100%'
        }"
      ></div>
      <div
        class="clause"
        v-if="!isAgreeState && (mainData.phone_page_type === 1 || mainData.phone_page_type === 2)"
      >
        <a href="http://cache.amap.com/h5/h5/publish/241/index.html">高德服务条款</a>
        <span>  |  </span>
        <a href="http://cache.amap.com/h5/h5/publish/238/index.html">隐私权政策</a>
      </div>
    </div>
    <!-- 引导呼气逻辑蒙层 -->
    <div class="mask" id="weixinMask" v-if="isMask" @click="clickEvent">
      <div class="arrow"></div>
      <div v-if="!isIos" class="guard android"></div>
      <div v-if="isIos" class="guard ios"></div>
    </div>

    <!-- 弹窗相关组件 -->
    <!-- 蒙层 -->
    <transition name="fade">
      <div class="modal-mask" ref="modalMask" v-if="maskShow"></div>
    </transition>
    <!-- 组件 -->
    <transition :name="noModalAnimation ? 'modal' : 'modal'">
      <!-- 通用弹窗 -->
      <CommonModal
        @modalHandler="modalHandler"
        v-if="modalCommonShow"
        :commonType="commonType"
      ></CommonModal>
      <!-- 手机号验证 -->
      <ValidateModal
        ref="validModel"
        @modalHandler="modalHandler"
        @rewardShow="reward"
        v-if="modalValidateShow"
        :mainData="mainData"
        :jumpAction="21"
        :location="{}"
      ></ValidateModal>
      <!-- 领取奖励 -->
      <RewardModal
        @modalHandler="modalHandler"
        v-if="modalRewardShow"
        :mainData="mainData"
        :dataAward="dataAward"
        :mini_app="mini_app"
        :isAliPayMainEntry="isAliPayMainEntry"
      ></RewardModal>
    </transition>
  </div>
</template>

<script>
/* eslint max-len:0, no-unused-expressions:0 */
import { util, os, log } from "@ali/amap-lib";
import browserApi from "../../../common/js/amap-browser";

// js
import service from "../../../common/js/service"; // 接口集中处理
import aosErrorHandle from "../../../common/js/aos-error-handler"; // 异常code码集中处理
import genModalMixin from "../../../common/js/gen-modal-mixin";
import genOpenAmapMixin from "../../../common/js/gen-openamap-mixin";
import MsgBox from "../../../common/js/msgbox"; // 通用msg弹窗
import toast from "../../../common/js/toast"; // 通用toast
import { EventBus } from "../../../common/js/event-bus";
import ShareTwo from "../../../common/js/Share"; // 分享配置
import shareData from "../../../config/config.share"; // 分享

// config
// import CONFIG_ACT from '../../../config/config.act'; // 活动配置文件
import CONFIG_AOS from "../../../config/config.aos"; // 接口链接

// vue
import ValidateModal from "../../../common/components/modal/ValidateModal.vue"; // 手机验证码弹窗形式
import RewardModal from "../../../common/components/modal/RewardModal.vue"; // 领券弹窗
import CommonModal from "../../../common/components/modal/Common.vue"; // 通用弹窗
import TitleBar from "../../../common/components/TitleBar.vue";

import {platFormData, dataType, accountList, accountName} from "../../../config/config.account" // 数据上报引入

const allModalList = [
  // 活动通用弹框
  "modalCommonShow",
  // 手机号验证
  "modalValidateShow",
  // 查看奖励
  "modalRewardShow",
  // 查看规则
  "modalRuleShow"
];


/**
 * mixin
 */
const modalMixin = genModalMixin(allModalList);
const openAmapMixin = genOpenAmapMixin();
export default {
  name: "app",
  mixins: [modalMixin, openAmapMixin],
  components: {
    TitleBar,
    CommonModal,
    ValidateModal,
    RewardModal
  },
  data() {
    return {
      token: "", // url是否带token，若有直接请求获取用户中奖信息
      isIos: !!os.ios, // 判断是否安卓或ios
      isMask: false, //
      titleData: { title: "首页", color: "#616161" },
      isInAmap: this.$root.isInAmap,
      isInAlipay: service.browserEnvironment() === "Alipay", //支付宝环境
      startPoiName: "",
      endPoiName: "",
      poiIndex: 0,
      timer: null,
      telNum: "", // 用户手机号码
      validNum: "", // 手机验证码
      validBtnStatus: true,
      validNumLength: 6,
      validBtnText: "获取验证码",
      validTimer: null,
      miniProgram: false, // 是否是小程序环境
      sessionid: "",
      mainData: {
        activity_type: 1, // # 活动类型，int，1表示旧H5领券，2表示新版H5领券，3表示比价
        title: "", // # 页面标题
        index_bg_color: "", // # 首页背景色
        has_passenger: 1, // #是否有乘客信息；1：有；0：无; 司拉乘用来判断是否需要乘客重新输入手机号
        logo: "", // 底部logo
        rule_desc: "", // # 活动规则
        // 老 H5 字段
        sub_title: "",
        amount: "",
        desc: "",
        index_image: "", // 首页图片
        // 新版h5和比价共有字段
        phone_page_type: null, // # 领券输入手机号形式(领券弹窗/领券页面),int，1表示领券弹窗，2表示领券页面
        page_top_image: "", // # 页面头图 string
        award_button_text: "", // # 领取按钮文案/string
        award_button_color: "", // # 按钮色值/string
        is_outer_activity: true, // # 是否支持端外领券/bool
        award_popup_title: "", // # 领券弹窗标题/富文本/string
        award_popup_button_desc: "", // # 领券弹窗按钮文案/富文本/stirng
        award_result_button_desc: "", // # 领券结果弹窗按钮文案/富文本/string
        award_suc_button_desc: "", // # 领取成功按钮文案/富文本/string
        // 以下是新版 H5 首页字段（拉新推广转化）
        award_bg_image: "", // # 领券区域背景图/string
        award_guide_desc: "", // # 领券引导文案/富文本/string
        // 以下是比价 H5 字段
        open_gps: true, // 是否开启定位 / bool
        no_verify: ""
      },
      gd_from: "", // 渠道来源
      mini_app: 0, // 默认高德地图发券（主板券）0：主板券；1:支付宝小程序券
      subsource: "", // 子渠道标识
      driver_sharecode: "", // 司拉乘分享参数 司拉乘必填
      share_type: "", // 司拉乘分享方式：1微信2朋友3二维码4收款码
      isOuterActivity: true, // 是否支持端外领券
      dataAward: {}, // 领券结果弹窗，假数据、假数据、假数据
      commonType: "", // 通用弹窗类型
      jumpAction: "", // 通用弹窗跳转链接
      browserEnvironment: "高德",
      focusPageFlag: false, // 弹窗获取焦点
      isAliPayMainEntry: false, // 支付宝金刚位
      isAgreeClause: false, // 是否同意服务协议
      isAgreeState: false, // 勾选协议是否显示
    };
  },
  async created() {
    this.browserEnvironment = service.browserEnvironment(); //
    console.log("环境", this.browserEnvironment);
    this.listenEmit(); // EventBus.$emit事件监听
    console.log("桥的信息>>>>>>>>>", this.$root.appInfo);
    const urlParam = util.getUrlParam();
    console.log(urlParam)
    // 2020-6-18添加数据上报功能，采用js步码方式
    if (urlParam.plat_form && platFormData.includes(urlParam.plat_form) && !dataType[urlParam.plat_form]['action']) {
      this.reportData(urlParam.plat_form)
    }
    if (urlParam.agree && urlParam.agree === 'show') {
      this.isAgreeState = true
    }
    this.isAliPayMainEntry = !!urlParam.mainentry;
    this.gd_from = urlParam.gd_from;
    this.mini_app = urlParam.mini_app || 0;
    this.token = urlParam.token;
    this.subsource = urlParam.subsource || "";
    this.driver_sharecode =
      urlParam.sharecode || urlParam.driver_sharecode || "";
    this.share_type = urlParam.sharetype || urlParam.share_type || "";
    log.log("pv", {
      source: this.gd_from,
      type: this.browserEnvironment,
      url: window.location.href,
      text: navigator.userAgent
    });
    const addScript = await new Promise(resolve => {
      if (service.browserEnvironment() === "Alipay") {
        // 支付宝环境内
        const AlipayScript = document.createElement("script");
        AlipayScript.type = "text/javascript";
        AlipayScript.src = "https://appx/web-view.min.js";
        document.body.appendChild(AlipayScript);
        resolve(true);
      } else {
        resolve(false);
      }
    });
    console.log(addScript, "是否引入小程序js");
    // this.typing("北京市朝阳区");
    if (this.token && this.token !== "undefined") {
      await this.checkToken(this.token);
    } else {
      await this.fetchMainData();
    }
    // 分享逻辑
    this.ShareController = new ShareTwo(); // 二次分享逻辑
    const mine = this;
    if (this.browserEnvironment === "Alipay") {
      console.log("支付宝环境内");
      /* eslint-disable */
      my.getEnv(res => {
        console.log("当前环境", res, res.miniprogram, JSON.stringify(res));
        if (res.miniprogram) {
          mine.miniProgram = res.miniprogram; // 判断是否是小程序环境
          console.log("小程序环境判断成功");
          //给小程序发信息要sessioni
          my.postMessage({ eventType: "GET_SESSION_ID" });
          console.log("小程序通信--发送消息成功");
          my.onMessage = function(e) {
            console.log("小程序通信-接收到消息", e);
            //拿到小程序传过来的sessionid
            mine.sessionid = e.sessionId;
            mine.handleGetVoucher();
            console.log(mine.sessionid, "sessionid---");
          };
        }
      });
    }
    // 二次分享配置
    delete urlParam.token; // 删除 url 中的token
    let search = "?";
    Object.keys(urlParam).forEach(key => {
      search += `${key}=${urlParam[key]}&`;
    });
    search = search.substring(0, search.length - 1);
    const url = `${window.location.origin}${window.location.pathname}${search}`;
    await service.transformUrl(url).then(dataUrl => {
      console.log("[微信授权之后的短链接]", dataUrl.transfer_url);
      shareData.url = dataUrl.transfer_url;
      console.log("二次分享配置", shareData);
    });
  },
  mounted() {},
  methods: {
    selectCheckBox() {
      var styleBox = document.getElementById('style-box')
      if(!styleBox && this.isAgreeClause) {
        styleBox = document.createElement('style');
        styleBox.id = 'style-box';
        styleBox.type = 'text/css';
        document.documentElement.appendChild(styleBox);
        styleBox.innerHTML = `.clause-input:checked {background: #fff !important}.clause-input:checked::after{border-color: ${this.mainData.index_bg_color || '#fff'} !important}`;
      }
    },
    goToPageAliPay () {
      location.href = 'https://ur.alipay.com/4ryZhM'
    },
    clickEvent() {
      // if (webviewInfo.isInWeixin()) {
      //   this.isMask = !this.isMask;
      // } else {

      // }
      if (this.mini_app === "1") {
        // 跳转小程序
        log.logJump(
          () => {
            browserApi.openAmap(
              "alipays://platformapi/startapp?appId=2018070960585195&page=page/map-index/map-index&query=channel%3Ddwfq"
            );
          },
          "gocar",
          {
            url: window.location.href
          }
        );
      } else {
        //呼起app
        this.openAmapClickHandle("index", true);
      }
    },
    listenEmit() {
      // 未开始
      EventBus.$on("activity.status.notBegin", () => {
        this.jumpAction = "";
        this.commonType = "notstart";
        this.modalHandler("modalOpen", "modalCommonShow");
      });
      // 已结束
      EventBus.$on("activity.status.ended", () => {
        this.jumpAction = "";
        this.commonType = "ended";
        this.modalHandler("modalOpen", "modalCommonShow");
      });
    },
    // 显示领券成功弹窗
    reward(awardData) {
      // 验证码弹窗需要传奖品数据过来
      if (awardData) {
        this.dataAward = awardData;
      }
      const urlParam = util.getUrlParam();
      const plat_form = urlParam.plat_form;
      if (plat_form && platFormData.includes(plat_form) && dataType[plat_form] && !dataType[plat_form]['action']) {
        if (plat_form.includes('tt') || plat_form.includes('dy') || plat_form.includes('dr') || plat_form.includes('ht') || plat_form.includes('md') || plat_form.includes('kd')) {
          meteor.track('form', { convert_id: dataType[plat_form]['convert_id'] });
        } else if (plat_form.includes('ks') || plat_form.includes('dk') || plat_form.includes('hk') || plat_form.includes('mk') || plat_form.includes('kk')) {
          _ks_trace.push({event: 'form', convertId: dataType[plat_form]['convert_id'], cb: function(){
            console.log('数据上报成功ks')
          }})
        } else if (plat_form.includes('tx') || plat_form.includes('dt') || plat_form.includes('hm') || plat_form.includes('kt') || plat_form.includes('mt') || plat_form.includes('zt')) {
          gdt('track', 'REGISTER', { 'date': new Date().toISOString()}); // 注册
          gdt('track', 'RESERVATION', {'date': new Date().toISOString()});// 预约
        } else if (plat_form.includes('gd')) {
          utq('track', 'FormSubmit', dataType[plat_form]['uc_id'])
        }
      }
      this.modalHandler("modalOpen", "modalRewardShow");
    },
    async checkToken(token) {
      const data = await service.token(token).catch(e => {
        console.log("异常处理>>>", e);
        aosErrorHandle(CONFIG_AOS.index, Number(e.code));
      });
      console.log("首页数据", data);
      if (!data) {
        return false;
      }
      this.mainData = data;
      const {
        is_outer_activity: isOuterActivity,
        title,
        award: awardData // token多一层中奖弹窗
      } = data;
      document.title = title;
      this.isOuterActivity = isOuterActivity; // 是否支持端外领券
      this.dataAward = awardData;
      this.modalHandler("modalOpen", "modalRewardShow"); // 如果链接里面带token，直接弹窗
    },
    async fetchMainData() {
      const data = await service
        .index(this.gd_from, this.driver_sharecode)
        .catch(e => {
          console.log("异常处理>>>", e);
          aosErrorHandle(CONFIG_AOS.index, Number(e.code));
        });
      console.log("首页数据", data);
      if (!data) {
        return false;
      }
      this.mainData = data;
      const {
        is_outer_activity: isOuterActivity,
        title,
        is_login: isLogin
      } = data;
      document.title = title;
      this.isOuterActivity = isOuterActivity; // 是否支持端外领券
      if (this.isInAmap && isLogin) {
        // 端内切用户登录
        // 如果用户登录 直接领奖
        this.handleGetVoucher();
      }
    },
    // typing(str) {
    //   const that = this;
    //   const poiNameLength = str.length;
    //   if (that.poiIndex <= poiNameLength) {
    //     that.startPoiName = str.slice(0, that.poiIndex++);
    //     that.timer = setTimeout(() => {
    //       that.typing(str);
    //     }, 200);
    //   } else {
    //     that.startPoiName = str; // 结束打字,移除 _ 光标
    //     clearTimeout(that.timer);
    //   }
    // },
    opentel() {
      this.logReward();
      if (this.isOuterActivity === false) {
        // 如果不支持端外领券
        this.clickEvent();
      } else {
        console.log("是否是小程序打开: ", this.miniProgram);
        if (this.miniProgram) {
          this.handleGetVoucher();
        } else {
          if (this.isAgreeState && !this.isAgreeClause && !this.isInAmap && !this.isInAlipay) {
            toast('请勾选同意高德服务协议和隐私政策')
            return
          }
          this.modalOpen("modalValidateShow");
        }
      }
    },
    logReward() {
      // 首页领券点击
      log.log("reward", {
        source: this.gd_from,
        type: this.browserEnvironment,
        url: window.location.href,
        text: navigator.userAgent
      });
    },
    // 处理4数限制
    handleInputLength() {
      if (this.validNum.length >= this.validNumLength) {
        this.validNum = this.validNum.slice(0, this.validNumLength);
      }
    },
    // 解决ios连续点击输入框键盘遮挡问题
    // fixed: 输入框获取焦点时键盘压盖弹窗
    setViewArea(type) {
      setTimeout(() => {
        const len = type === "phone" ? 150 : 180;
        this.focusPageFlag = true;
        window.scrollTo(0, len);
      }, 0);
    },
    // 解决ios12键盘收起页面不能下来的问题
    temporaryRepair() {
      this.focusPageFlag = false;
      this.$nextTick(() => {
        setTimeout(() => {
          if (!this.focusPageFlag) {
            window.scrollTo(0, 0); // 页面向下滚动
          }
        }, 200);
      });
      // this.$nextTick(() => {
      //   window.scrollTo(0, 0); // 页面向下滚动
      // });
    },
    // 重新获取umid
    getUmid() {
      return new Promise((r, j) => {
        umM.init(
          {
            appName: "amap-aos-oss"
          },
          (initState, result) => {
            const timer = setTimeout(() => {
              j(new Error("umid init timeout"));
            }, 5000);
            if (initState === "success") {
              clearTimeout(timer);
              umidToken = result.tn;
              console.log("umidToken>>>>>>", umidToken);
              r(umidToken);
            } else {
              clearTimeout(timer);
              j(new Error("umid init faild"));
            }
          }
        );
      });
    },
    // 强制刷新
    refresh() {
      MsgBox({
        content: "页面参数获取失败，请刷新页面",
        btns: [
          // msgbox按钮列表，可以多个按钮
          {
            text: "确认", // 按钮文案
            fun: () => {
              window.location.reload();
            }, // 点击按钮触发的方法
            noClose: false // 是否不需要关闭弹窗，默认（false）需要关闭
          }
        ]
      });
    },
    // 获取验证码
    getValidNum() {
      if (this.telStatus && this.validBtnStatus) {
        log.log("validate", {
          source: this.gd_from,
          type: this.browserEnvironment,
          url: window.location.href,
          text: navigator.userAgent
        });
        this.validBtnStatus = false;
        const umidToken = fyOBJ.umidToken || '';
        if (umidToken.indexOf("defaultToken") !== -1) {
          if (!umM) {
            // 强制刷新页面
            this.$refs.validModel.refresh();
          } else {
            // 从新初始化umidtoken
            this.getUmid()
              .then(t => {
                console.log(t);
                const params = [
                  { mobile: this.telNum, sign: 1 },
                  { umid_token: t, sign: 1 },
                  {
                    ts: new Date()
                      .getTime()
                      .toString()
                      .substr(0, 10),
                    sign: 1
                  }
                ];
                console.log("获取验证码请求参数1", params, CONFIG_AOS.verify);
                this.handleVerify(params);
              })
              .catch(e => {
                console.log(e);
                // 强制刷新
                this.refresh();
              });
          }
        } else {
          const params = [
            { mobile: this.telNum, sign: 1 },
            { umid_token: umidToken, sign: 1 },
            {
              ts: new Date()
                .getTime()
                .toString()
                .substr(0, 10),
              sign: 1
            }
          ];

          console.log("获取验证码请求参数2", params, CONFIG_AOS.verify);
          this.handleVerify(params);
        }
      }
    },
    // 获取验证码请求方法
    async handleVerify(params) {
      const data = await service.verify(params).catch(e => {
        const code = +e.code;
        if (code === 1001) {
          MsgBox({
            content: "您点的太快了，请稍后尝试",
            btns: [
              // msgbox按钮列表，可以多个按钮
              {
                text: "关闭", // 按钮文案
                fun: () => {}, // 点击按钮触发的方法
                noClose: false // 是否不需要关闭弹窗，默认（false）需要关闭
              }
            ]
          });
          setTimeout(() => {
            this.validBtnStatus = true;
          }, 1000);
        }
      });
      if (!data) {
        return false;
      }
      this.validBtnText = 60;
      this.validTimer = setInterval(() => {
        if (this.validBtnText === 0) {
          this.validTimer = clearInterval(this.validTimer);
          this.validBtnStatus = true;
          this.validBtnText = "获取验证码";
          return;
        }
        this.validBtnText--;
      }, 1000);
    },
    authCodeGetReward() {
      ap.getAuthCode(
        {
          appId: '2018071260620019', // 郑娜测网
          // appId: "2021002145601686", // lzl测试用
          scopes: ["auth_user"]
        },
        res => {
          if (res.authCode) {
            this.handleGetVoucher(res.authCode);
          } else {
            toast("哎呀，出错了，请稍后再试");
          }
        }
      );
    },
    // 端内外领券
    handleGetVoucher(authCode) {
      console.log(this.isInAmap, "this.isInAmap");
      if (this.clickTime && new Date().getTime() - this.clickTime < 1000) {
        return;
      }
      this.clickTime = new Date().getTime();
      this.ts = Math.floor(new Date().getTime() / 1000);
      if (this.isAliPayMainEntry) {
        // 支付宝金刚位领券
        const params = [
          { source: this.gd_from, sign: 1 },
          { ts: this.ts, sign: 1 },
          { mini_app: this.mini_app }, // mini_app 1：小程序券（支付宝-高的打车小程序中使用） 0：端内（高德地图-高的打车）使用
          { auth_code: authCode }
        ];
        this.rewardData(params, this.isInAmap);
      } else if (this.isInAmap) {
        const { is_login: isLogin } = this.mainData;
        const params = [
          { source: this.gd_from, sign: 1 },
          { mobile: this.telNum.trim(), sign: 1 },
          { ts: this.ts, sign: 1 },
          { mini_app: this.mini_app }, // mini_app 1：小程序券（支付宝-高的打车小程序中使用） 0：端内（高德地图-高的打车）使用
          { subsource: this.subsource }, // 司拉乘新增driver_sharecode和share_type
          { driver_sharecode: this.driver_sharecode },
          { share_type: this.share_type },
          { tid: this.$root.appInfo.tid }
        ];
        if ((!isLogin && this.telStatus) || isLogin) {
          this.rewardData(params, this.isInAmap);
        }
      } else if (this.miniProgram) {
        console.log(
          "是否是小程序呀: ",
          this.miniProgram,
          "sessionId: ",
          this.sessionid
        );
        const params = [
          { source: this.gd_from, sign: 1 },
          { mobile: "", sign: 1 },
          { ts: this.ts, sign: 1 },
          { mini_app: this.mini_app }, // mini_app 1：小程序券（支付宝-高的打车小程序中使用） 0：端内（高德地图-高的打车）使用
          { sessionid: this.sessionid },
          { req_from: "miniApp" }
        ];
        this.rewardData(params, this.isInAmap);
      } else if (
        this.isInAlipay &&
        !this.miniProgram &&
        this.mainData.no_verify
      ) {
        console.log(
          "支付宝领券走这个领券传参",
          this.isInAlipay,
          this.mainData.no_verify
        );
        console.log(this.gd_from, this.telNum.trim(), this.subsource);
        // this.telNum.trim(),this.ts,this.mini_app,this.subsource,this.driver_sharecode,this.share_type,this.$root.appInfo.tid
        const params = [
          { source: this.gd_from, sign: 1 },
          { mobile: this.telNum.trim(), sign: 1 },
          { ts: this.ts, sign: 1 },
          { mini_app: this.mini_app } // mini_app 1：小程序券（支付宝-高的打车小程序中使用） 0：端内（高德地图-高的打车）使用
        ];
        this.rewardData(params, this.isInAmap);
      } else {
        // 端外领券
        const urlParams = util.getUrlParam();
        const plat_form = urlParams.plat_form;
        const params = [
          { source: this.gd_from, sign: 1 },
          { mobile: this.telNum.trim(), sign: 1 },
          { ts: this.ts, sign: 1 },
          { verify_code: this.validNum },
          { mini_app: this.mini_app }, // mini_app 1：小程序券（支付宝-高的打车小程序中使用） 0：端内（高德地图-高的打车）使用
          // { subsource: this.subsource },
          { rootUrl: location.href || '' },
          { subsource: plat_form || this.subsource || '' }, // 2021-7-14 作为数据上报参数
          // 司拉乘新增driver_sharecode和share_type
          { driver_sharecode: this.driver_sharecode },
          { share_type: this.share_type }
        ];
        // if (plat_form && platFormData.includes(plat_form)) {
        //   // to do
        //   const ad_channel = dataType[plat_form]['ad_channel']
        //   if (ad_channel) {
        //     params.push({ad_channel})
        //   }
        //   if (ad_channel === 1 && dataType[plat_form]['action'] && (urlParams.qz_gdt || urlParams.gdt_vid || urlParams.click_ext)) {
        //     params.push({"ad_data":JSON.stringify({"url": location.host, "qz_gdt": urlParams.qz_gdt ? urlParams.qz_gdt : urlParams.gdt_vid ? urlParams.gdt_vid : "", "click_ext": urlParams.click_ext ? urlParams.click_ext : ""})})
        //   } else if (ad_channel === 3 && dataType[plat_form]['action'] && urlParams.clickid) {
        //     params.push({"ad_data": JSON.stringify({"url": encodeURIComponent(location.href), "click_id": urlParams.clickid})})
        //   } else if (ad_channel === 4 && dataType[plat_form]['action'] && urlParams.callback) {
        //     params.push({"ad_data": JSON.stringify({"callback": urlParams.callback})})
        //   }
        // }
        const accountIndex = accountName.indexOf(plat_form && plat_form.substr(0, 2));
        if (plat_form && accountIndex !== -1) {
          const ad_channel = accountList[accountIndex]['ad_channel'] | 0;
          if (ad_channel) {
            params.push({ad_channel})
          }
          if (ad_channel === 1 && (urlParams.qz_gdt || urlParams.gdt_vid || urlParams.click_ext)) {
            params.push({"ad_data":JSON.stringify({"url": location.host, "qz_gdt": urlParams.qz_gdt ? urlParams.qz_gdt : urlParams.gdt_vid ? urlParams.gdt_vid : "", "click_ext": urlParams.click_ext ? urlParams.click_ext : ""})})
          } else if (ad_channel === 3 && urlParams.clickid) {
            params.push({"ad_data": JSON.stringify({"url": encodeURIComponent(location.href), "click_id": urlParams.clickid})})
          } else if (ad_channel === 4 && urlParams.callback) {
            params.push({"ad_data": JSON.stringify({"callback": urlParams.callback})})
          }
        }
        if ((this.telStatus && this.validStatus) || this.stepCode) {
          if (this.isAgreeState && !this.isAgreeClause && !this.isInAmap && !this.isInAlipay) {
            toast('请勾选同意高德服务协议和隐私政策')
            return
          }
          // 调用领取接口
          this.rewardData(params, this.isInAmap);
        }
      }
    },
    async rewardData(params, isInAmap) {
      this.logReward();
      // 统一添加接入人机参数
      const { umidToken = '' } = fyOBJ;
      params.push({ ua: fyOBJ.getUA() || ''},{ umidToken },{asac:"2A20402V011135EFX42JI2"})
      const dataAward = await service.reward(params, isInAmap).catch(error => {
        const code = +error.code;
        if (code === 130) {
          // todo
          // 未绑定手机号不处理
        } else if (code === 201003) {
          // 获取高德账号失败
          toast('哎呀，出错了，请稍后再试')
        } else {
          console.log("出错了", code);
          //后续要去掉code === 12
          if (code === 14 || code === 12) {
            console.log("sessionid参数校验错误");
            my.postMessage({ eventType: "TO_LOGIN" });
          } else {
            aosErrorHandle(CONFIG_AOS.get, code);
          }
        }
      });
      if (!dataAward) {
        return false;
      }

      this.dataAward = dataAward;
      console.log("dataAward --- app.vue 弹窗", dataAward);

      // 优惠领取结果处理
      const status = Number(this.dataAward.award_status);
      if (status === 0) {
        toast("活动太火爆，券已经被领完啦～");
      } else if (status === 1 || status === 2) {
        this.reward(this.dataAward);
      } else if (status === 3) {
        toast("老用户领券活动已结束");
      } else if (status === 4) {
        toast("您的周卡已领取");
      } else if (status === 5) {
        toast("您的领取次数已达上限");
      } else if (status === 6) {
        toast("您已经领取过新用户券了");
      }
    },
    // 数据上报（js布码）
    reportData (type) {
      if (!dataType[type] || document.querySelector(('#'+type+dataType[type]['sid']))) return;
      let s = document.createElement('script'),ns = document.createElement('noscript');
      s.type = "text/javascript";
      s.id = type + dataType[type]['sid'];
      if (type.includes('tt') || type.includes('dy') || type.includes('dr') || type.includes('ht') || type.includes('md') || type.includes('kd')) {
        s.innerHTML = `(function(r,d,s,l){var meteor=r.meteor=r.meteor||[];meteor.methods=["track","off","on"];meteor.factory=function(method){return function(){
          var args=Array.prototype.slice.call(arguments);args.unshift(method);meteor.push(args);return meteor}};for(var i=0;i<meteor.methods.length;i++){
          var key=meteor.methods[i];meteor[key]=meteor.factory(key)}meteor.load=function(){var js,fjs=d.getElementsByTagName(s)[0];js=d.createElement(s);
          js.src="https://analytics.snssdk.com/meteor.js/v1/"+l+"/sdk";fjs.parentNode.insertBefore(js,fjs)};meteor.load();if(meteor.invoked){return}
          meteor.invoked=true;meteor.track("pageview")})(window,document,"script","${dataType[type]['sid']}");`
      } else if (type.includes('ks') || type.includes('dk') || type.includes('hk') || type.includes('mk') || type.includes('kk')) {
        s.innerHTML =  `(function (root) { 
          var ksscript = document.createElement('script');
          ksscript.setAttribute('charset', 'utf-8');
          ksscript.src = 'https://static.yximgs.com/udata/pkg/ks-ad-trace-sdk/ks-trace.3.2.0.min.js';
          var s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(ksscript, s);})(window);`
      } else if (type.includes('tx') || type.includes('dt') || type.includes('hm') || type.includes('kt') || type.includes('mt') || type.includes('zt')) {
        s.innerHTML = `!function(g,d,t,e,v,n,s){if(g.gdt)return;v=g.gdt=function(){v.tk?v.tk.apply(v,arguments):v.queue.push(arguments)};v.sv='1.0';v.bt=0;v.queue=[];n=d.createElement(t);n.async=!0; n.src=e;s=d.getElementsByTagName(t)[0];s.parentNode.insertBefore(n,s);}(window,document,'script', 'https://qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js');gdt('init','${dataType[type]['set_id']}');gdt('track','PAGE_VIEW');`
        let img = document.createElement('img');
        img.width = 1;
        img.height = 1;
        img.style.display = "none";
        img.src = `https://a.gdt.qq.com/pixel?user_action_set_id=${dataType[type]['set_id']}&action_type=PAGE_VIEW&noscript=1`
        ns.appendChild(img)
      } else if (type.includes('gd')) {
        s.innerHTML = `(function(w,d,t,s,q,m,n){if(w.utq)return;q=w.utq=function(){q.process?q.process(arguments):q.queue.push(arguments);};q.queue=[];m=d.getElementsByTagName(t)[0];n=d.createElement(t);n.src=s;n.async=true;m.parentNode.insertBefore(n,m);})(window,document,'script','https://image.uc.cn/s/uae/g/0s/ad/utracking.js');utq('set', 'convertMode', true);utq('set', 'trackurl', 'huichuan.sm.cn/lp');`
      }
      
      document.head.appendChild(s);
      if (type.includes('tx') || type.includes('dt') || type.includes('hm') || type.includes('kt') || type.includes('mt') || type.includes('zt')) {
        document.head.appendChild(ns);
      }
    }
  },
  computed: {
    telStatus() {
      return /^(1[3-9])\d{9}$/.test(this.telNum.trim());
    },
    validStatus() {
      return (
        this.validNum.trim() &&
        this.validNum.trim().length === this.validNumLength
      );
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../../common/css/common-mixin";
#app {
  width: 100%;
  min-height: 100%;
  position: relative;
  font-family: PingFangSC-Medium, sans-serif;
  display: flex;
  flex-direction: column;
  color: #fff;
}
.header {
  width: 100%;
  height: 5.7rem;
  // background-image: url(~assets/index/header.png);
  background-repeat: no-repeat;
  background-size: 100%;
}
.content {
  margin: -0.01rem auto 0;
  width: 100%;
  text-align: center;
}
.coin {
  margin: -1rem auto -0.01rem;
  width: 100%;
  height: 2rem;
  background-image: url(~assets/index/coin.png);
  background-repeat: no-repeat;
  background-size: 100%;
}
.get-reward-content {
  width: 100%;
}
.btn-reward {
  margin: 0 auto 0.4rem;
  width: 6.19rem;
  height: 0.88rem;
  text-align: center;
  line-height: 0.96rem;
  background: #4287ff;
  border-radius: 1rem;
  font-size: 0.36rem;
  color: #fff;
}
.btn-reward-out {
  color: #fff;
  background: #547eff;
}
.guide-desc {
  color: #fff;
  padding: 0 0.3rem;
  margin: -0.2rem auto 0.2rem;
  font-size: 0.56rem;
  text-align: center;
}
.error {
  display: block;
  color: aqua;
  margin: 0.3rem 0 0 0;
}
.rule-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .rule-desc {
    width: 6.2rem;
    text-align: left;
  }
  .rule-title {
    width: 6.2rem;
    height: 0.25rem;
    margin-bottom: 0.2rem;
    background-image: url(~assets/index/rule-title.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
.clause-body {
  display: flex;
  font-size: 0.24rem;
  margin-bottom: .5rem;
  align-items: center;
  justify-content: center;
  .clause-input {
    outline: none;
    width: .26rem;
    height: .26rem;
    border-radius: 0;
    background-color: #fff;
    border: solid 1px #ddd;
    font-size: .8rem;
    margin-right: .1rem;
    position: relative;
    display: inline-block;
    vertical-align: middle;
    cursor: default;
    -webkit-appearance: none;
    user-select: none;
    -webkit-user-select: none;
    -webkit-transition: background-color ease .25s;
    transition: background-color ease .25s;
  }
  .clause-input:checked {
    background: #1673ff;
    border: solid 1px #1673ff;
  }
  .clause-input:checked::after {
    content: "";
    top: 0;
    left: 0;
    right: 0;
    bottom: .03rem;
    margin: auto;
    position: absolute;
    background: transparent;
    border: #fff solid 2px;
    border-top: none;
    border-right: none;
    height: .1rem;
    width: .18rem;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  label {
    display: inline-block;
    vertical-align: middle;
  }
  span {
    vertical-align: middle;
  }
  a {
    vertical-align: middle;
    text-decoration: none;
    color: #fff;
    font-weight: 700;
  }
}
.clause {
  margin-bottom: 0.2rem;
  a {
    color: #fff;
    vertical-align: middle;
    text-decoration: none;
  }
  span {
    vertical-align: middle;
  }
}
.logo {
  margin: 0.5rem auto 1rem;
  width: 7.5rem;
  height: 1.12rem;
  // background-image: url(~assets/index/logo.png);
  background-repeat: no-repeat;
  background-size: 100%;
}
.close {
  position: absolute;
  z-index: 1;
  right: rpx(20);
  top: rpx(20);
  width: rpx(36);
  height: rpx(36);
  text-align: center;
  background: url(../../../assets/index/close-btn-pic.png) no-repeat center/100%;
}
.title_text {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: rpx(200);
  text-align: center;
  font-size: rpx(48);
  margin-bottom: rpx(20);
  color: #000000;
}
.input_content-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: rpx(619);
  margin: 0 auto;
  // margin-bottom: rpx(86);
  .line_wrap {
    width: 100%;
    height: rpx(88);
    margin-bottom: 0.2rem;
    .tel {
      width: 100%;
      height: 100%;
      padding-left: rpx(50);
    }
    .input {
      font-size: rpx(32);
      border: 1px solid transparent;
      border-left-color: transparent;
      outline: none;
      border-radius: 0.5rem;
    }
  }
  .vali_wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .vali_num {
      width: 3.61rem;
      height: 100%;
      padding-left: rpx(50);
    }
    .vali_btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: rpx(239);
      height: rpx(88);
      border-radius: 0.5rem;
      color: #fff;
      font-size: 0.32rem;
      border: 1px solid #fff;
      // background: #3377ff;
      &.disablevali {
        color: rgba(255, 255, 255, 0.6);
        border: 1px solid rgba(255, 255, 255, 0.6);
      }
    }
  }
}
.confirm_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: rpx(520);
  height: rpx(80);
  margin: 0 auto;
  background-color: #547eff;
  color: #fff;
  font-size: rpx(36);
  font-weight: 600;
  border-radius: rpx(16);
  // border: 1px solid orange;
}
.disable {
  background-color: #c9c9c9;
}
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.6);
  .arrow {
    position: absolute;
    right: rpx(40);
    top: rpx(30);
    width: rpx(115);
    height: rpx(79);
    background: url("~assets/index/mask/arrow.png") no-repeat;
    background-size: contain;
    animation: shake 1s ease-in-out infinite normal;
    @keyframes shake {
      0% {
        transform: translate(0, 0);
      }
      25% {
        transform: translate(0, -0.1rem);
      }
      50% {
        transform: translate(0, 0);
      }
      70% {
        transform: translate(0px, -0.05rem);
      }
      100% {
        transform: translate(0, 0);
      }
    }
  }
  .guard {
    position: absolute;
    right: rpx(165);
    top: rpx(20);
    &.android {
      width: rpx(280);
      height: rpx(148);
      background: url("~assets/index/mask/get-and.png") no-repeat left center;
      background-size: rpx(280) rpx(148);
    }
    &.ios {
      width: rpx(280);
      height: rpx(148);
      background: url("~assets/index/mask/get-ios.png") no-repeat left center;
      background-size: rpx(280) rpx(148);
    }
  }
}
</style>
